import { defaults } from './defaults.es.js';
const calcDampingRatio = function () {
  let stiffness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaults.stiffness;
  let damping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaults.damping;
  let mass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaults.mass;
  return damping / (2 * Math.sqrt(stiffness * mass));
};
export { calcDampingRatio };